<script lang="ts">
  const { children } = $props();
</script>

<div>
  {@render children()}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    font-family: "OttoSansMedium", sans-serif;
    font-size: 14px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
